import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AlertController, ToastController } from 'ionic-angular';
import { ServiceProvider } from './ServiceProvider';
import { SessionProvider } from './SessionProvider';

/*
  Generated class for the LoginProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class LoginProvider {

    constructor(public alertCtrl: AlertController, public serviceProvider: ServiceProvider, public sessionProvider: SessionProvider, public toastController: ToastController) {
        console.log('Hello LoginProvider Provider');
    }

    public presentPrompt() {
        return new Promise((resolve, reject) => {
            let alert = this.alertCtrl.create({
                cssClass: 'Login',
                title: 'ورود',
                message: 'برای دریافت نام کاربری و کلمه عبور به انجمن تولید کنندگان فولاد مراجعه کنید',
                inputs: [
                    {
                        name: 'username',
                        placeholder: 'نام کاربری'
                    },
                    {
                        name: 'password',
                        placeholder: 'کلمه عبور',
                        type: 'password'
                    }//,
                    //{
                    //    name: 'checkbox3',
                    //    type: 'checkbox',
                    //    label: 'مرا به خاطر بسپار',
                    //    value: 'true'
                    //}
                ],
                buttons: [
                    {
                        text: 'انصراف',
                        role: 'cancel'
                    },
                    {
                        text: 'ورود',
                        handler: data => {

                            var randomNumber = this.sessionProvider.getUniqId();


                            this.serviceProvider.Get("Client/Login?username=" + data.username + "&pwd=" + data.password + "&uniquecode=" + randomNumber, false).then((result) => {
                                console.log(result[0]);
                                if (result[0].a_Response == 0) {
                                    let loginData = {
                                        Token: result[0].Token,
                                        Name: result[0].clName,
                                        Username: data.username,
                                        RoleName: result[0].rName,
                                        tRoleId: result[0].tRoleId,
                                        tOwnerId: result[0].tOwnerId,
                                        Id: result[0].tClientId,
                                        ExpDate: result[0].ExpDate,
                                    };
                                    this.sessionProvider.setMember(loginData);
                                    alert.dismiss();
                                    resolve(loginData);
                                }
                                else {
                                    const toast = this.toastController.create({
                                        message: result[0].a_Message,
                                        duration: 2000
                                    });
                                    toast.present();
                                }
                            });
                            return false;
                        }
                    }
                ]
            });
            alert.present();

        });
    }


    public ShowDetails() {
        let message: string = '';
        message = "مشخصات کاربر: " + this.sessionProvider.getFullname() + "<br />";
        message += "تاریخ اتمام کاربری: " + this.sessionProvider.getMember().ExpDate + "<br />";
        //message += "تاریخ اتمام کاربری: ";
        let alert = this.alertCtrl.create({
            cssClass: 'Login',
            title: 'ورود',
            message: message,
            inputs: [
                {
                    name: 'pass',
                    placeholder: 'رمز عبور جدید',
                    type: 'password'
                },
                {
                    name: 'repass',
                    placeholder: 'تکرار رمز عبور جدید',
                    type: 'password'
                }
            ],
            buttons: [
                {
                    text: 'انصراف',
                    role: 'cancel'
                },
                {
                    text: 'ذخیره',
                    handler: data => {

                        var randomNumber = this.sessionProvider.getUniqId();


                        this.serviceProvider.Get("/Client/ChangePass/" + this.sessionProvider.getMember().Id + "/" + data.pass, false).then((result) => {
                            console.log(result);
                            const toast = this.toastController.create({
                                message: "رمز عبور با موفقیت تغییر کرد",
                                duration: 2000
                            });
                            toast.present();
                            alert.dismiss();
                        });
                        return false;
                    }
                }
            ]
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/providers/LoginProvider.ts